/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nextslide1Inputs */

const he_common_nextslide1 = /** @type {(inputs: Common_Nextslide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שקופית הבאה`)
};

const en_common_nextslide1 = /** @type {(inputs: Common_Nextslide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Common_Nextslide1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_nextslide1 = /** @type {((inputs?: Common_Nextslide1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nextslide1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_nextslide1(inputs)
	return en_common_nextslide1(inputs)
});
export { common_nextslide1 as "common_nextSlide" }